// extracted by mini-css-extract-plugin
export default {"container":"SubsectionWithFallback__container-URvjR"};